import "./MarketPlace.css";
import { Helmet } from "react-helmet";
import Sidebar from "../components/Sidebar/Sidebar";
import Topbar from "../components/Topbar/Topbar";
import AffiliateModal from "../components/Modals/Affiliate/Affiliate";
import { useState } from "react";
import Search from "../components/Search/Search";
import Products from "../components/Products/Products";
import SidebarMobile from "../components/Sidebar/Mobile/SidebarMobile";

const AffiliateMarketPlace = () => {
 const [affiliateModal, setAffiliateModal] = useState(false);

 return (
  <div className="marketplace-dashboard">
   <Helmet>
    <title> Marketplace | Dashboard | SHAP</title>
    <meta
     name="description"
     content="Knowledge-based digital products distribution at a premium"
    />
   </Helmet>
   <div className="wrapper">
    <div className="side-bar">
     <Sidebar active="product" />
    </div>
    <div className="side-bar-mobile">
     <SidebarMobile active="product" />
    </div>
    <div className="content-container">
     <div className="modal-wrapper">
      <div
       className="referal"
       style={{ display: affiliateModal ? "block" : "none" }}
      >
       <AffiliateModal setAffiliateModal={setAffiliateModal} />
      </div>
     </div>

     <Topbar heading="Product Marketplace" />

     <div className="inner-content">
      <p style={{ color: "var(--primary-grey-text)" }}>
       Dashboard {">"} Product marketplace
      </p>
      <div className="search-wrapper">
       <Search />
      </div>
      <div className="products-wrapper">
       <Products setAffiliateModal={setAffiliateModal} />
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default AffiliateMarketPlace;
